import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

export default {
	QUALITY_ANNOTATIONS: {
		ACTIVE: true,
		NAME: 'manage-quality-annotations',
		LABEL: 'Quality Annotations',
		ICON: 'content-file-confirm',
		PATH: '/quality-assessment/:section',
		CHILDREN: [
			'QUALITY_ANNOTATIONS_BATCHES_LIST',
			'QUALITY_ANNOTATIONS_ROUTINES_LIST',
			'QUALITY_ANNOTATIONS_NEW_REQUEST',
			'QUALITY_ANNOTATIONS_NEW_ROUTINE',
		],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},

	QUALITY_ANNOTATIONS_BATCHES_LIST: {
		ACTIVE: true,
		NAME: 'quality-annotations-batches-list',
		LABEL: 'Quality Annotations Batches List',
		PARAMS: { section: 'requested' },
		PERMISSIONS,
	},
	QUALITY_ANNOTATIONS_ROUTINES_LIST: {
		ACTIVE: true,
		NAME: 'quality-annotations-routines-list',
		LABEL: 'Quality Annotations Routines List',
		PARAMS: { section: 'routines' },
		PERMISSIONS,
	},
	QUALITY_ANNOTATIONS_NEW_REQUEST: {
		ACTIVE: true,
		NAME: 'quality-annotations-new-request',
		LABEL: 'New Quality Annotations Request',
		PARAMS: { section: 'new-request' },
		PERMISSIONS,
	},
	QUALITY_ANNOTATIONS_NEW_ROUTINE: {
		ACTIVE: true,
		NAME: 'quality-annotations-new-routine',
		LABEL: 'New Quality Annotations Routine',
		PARAMS: { section: 'new-routine' },
		PERMISSIONS,
	},
};
